const svgResources = require.context("../../assets/icon", false, /\.svg$/);
svgResources.keys().forEach((svg) => {
  svgResources(svg);
});
